import React from 'react';

export default function(){
    return (
        <div>Not Found</div>
    )
}
